import { ChangeEvent, useState } from "react";
import { controlToastState, Modal, TextInput } from "risa-oasis-ui_v2";
import { FirestoreService } from "../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../api/firebase/references";
import { sendInviteViaEmail } from "../../../api/postCall/sendInviteViaEmail";
import CustomRadioButton from "../../customRadioButton/customRadioButton";

interface InvitationModalProps {
  facilityId: string;
  onModalClose?: (boolean) => void;
}
const HealthCareInvitationModal = (props: InvitationModalProps) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState("0");

  const isAdminOptions = [
    { label: "Yes", value: "1" },
    { label: "No", value: "0" },
  ];

  const handleInputChange = (data) => {
    if (data.name === "name") {
      setName(data.value);
    } else {
      setEmail(data.value);
    }
  };

  const addInvitationToFirebase = async () => {
    setLoading(true);
    const invitation = {
      email: email,
      name: name,
      facilityId: props.facilityId,
      isAdmin: isAdmin === "1",
      roleId: "nurse",
      status: "invited",
    };

    try {
      await FirestoreService.addDocument(
        FirestoreCollectionReference.hc_facility_invitations(),
        invitation,
      );
      await sendInviteViaEmail(email);
      controlToastState("invitation-success");
      props?.onModalClose && props?.onModalClose(false);
    } catch (error) {
      console.error("Error adding document: ", error);
      controlToastState("invitation-failed");
    } finally {
      setName("");
      setEmail("");
      setLoading(false);
    }
  };

  const onModalClose = () => {
    setName("");
    setEmail("");
    props?.onModalClose && props?.onModalClose(false);
  };
  return (
    <Modal
      dialogId={"invitation-modal"}
      onSave={addInvitationToFirebase}
      title={"Invite Member"}
      saveButtonText={loading ? "Inviting..." : "Invite"}
      cancelText={"Cancel"}
      disableSave={name.trim() === "" || email.trim() === "" || loading}
      onClose={onModalClose}
    >
      <div className="invitation-form-container">
        <form>
          <TextInput
            id={"name"}
            label={"Name"}
            required
            onChange={handleInputChange}
            error={name.trim() === "" ? "Please provide a name" : ""}
            resetField={name === ""}
          />
          <TextInput
            id={"email"}
            label={"Email"}
            required
            onChange={handleInputChange}
            error={email.trim() === "" ? "Please provide an email" : ""}
            resetField={email === ""}
          />
          <div className="radio-button-container">
            <div className="radio-button-container--heading">
              Should the user be an Admin?
            </div>
            <div className="radio-button-container--buttons">
              {isAdminOptions.map((option) => (
                <CustomRadioButton
                  key={option.value}
                  name={"isAdmin"}
                  value={option.value}
                  checked={isAdmin === option.value}
                  label={option.label}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setIsAdmin(e.target.value)
                  }
                />
              ))}
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default HealthCareInvitationModal;
